export default __webpack_public_path__ + "static/media/img_0.ef9de398.jpg";